<template>
   <div>
      <el-dialog 
         :visible.sync="logoDialogVisible" 
         :title="`TaskMan ${$t('用户中心')}`" 
         class="lang-menu"
         :before-close="handleClose">
         <div class="each-menu" @click="changeLanguage()">
            <img src="@/assets/images/common/lang.png" alt="">
            <div class="label">{{ $t('语言') }}</div>
         </div>
         <div class="each-menu" @click="aboutDialogVisible = true">
            <img src="@/assets/images/common/about.png" alt="">
            <div class="label">{{ $t('关于') }}</div>
         </div>
      </el-dialog>
      <about-part :aboutVisible.sync="aboutDialogVisible"></about-part>
   </div>
</template>
<script>
import AboutPart from './AboutPart.vue'

export default {
   components:{
      AboutPart,
   },
   props:{
     logoDialogVisible: {
        type: Boolean,
        default: false
      }
   },
   data(){
      return {
         aboutDialogVisible:false,
      }
   },
   methods: {
      handleClose() {
         this.$emit('update:logoDialogVisible', false);
      },
      //切换语言
      changeLanguage(){
         let lang = this.$i18n.locale == 'zh' ? 'en' : 'zh';
         this.$i18n.locale = lang;
         localStorage.setItem('tmUserLang', lang);
      }
   }
}
</script>
<style scoped lang="scss">
.lang-menu{
   ::v-deep .el-dialog{
      width: 394px;
      height: 214px;
      border-radius: 12px; 
      background: #262626;
      .el-dialog__body{
         padding-top: 30px;
         display: flex;
         align-items: center;
         justify-content: center;
         div:first-child{
            margin-right: 40px;
         }
      }
      .el-dialog__header{
         height: 26px;
      }
      .el-dialog__title{
         font-weight: bold;
         font-size: 20px;
         line-height: 23px;
         color: #FFFFFF;
      }
      .el-dialog__close::before{
         font-size: 22px;
         color: #FFFFFF;
      }
      .each-menu{
         img{
            width: 70px;
            height: 70px;
            margin-bottom: 5px;
         }
         .label{
            font-size: 16px;
            color: #FFFFFF;
         }
      }
   }
}
</style>